export default __webpack_public_path__ + "./fonts/checkbox-checked.bf1a2129.svg";